import { isArray } from '@lhb/func';
import { ControlType, parseValueCatch } from '../DynamicComponent/config';
import V2Message from '../../Others/V2Hint/V2Message';

// 审批状态
export enum ApprovalStatus {
  Untreated = 0, // 未处理
  Passed, // 已通过
  Denied, // 已拒绝
  Revoke, // 审核撤销
  Reject, // 已驳回
}

// 审批节点状态（中台维护的）
export enum ApprovalNodeStatus {
  Process = 1, // 处理中
  Approved, // 审核通过
  Denied, // 审核拒绝
  Reject, // 审核驳回
}

// 审批节点审批人状态（中台维护的）
export enum ApprovalNodeOperatorStatus {
  Process = 1, // 处理中
  Approved, // 审核通过
  Denied, // 审核拒绝
  Transfer, // 转交
  Reject, // 审核驳回
}

/**
 * @Description 审批详情权限
 */
export enum ApprovePermission {
  Transfer = 'transfer', // 转交
  Withdraw = 'withdraw', // 撤回
  Reject = 'reject', // 拒绝
  Rebut = 'rebut', // 驳回
  Edit = 'edit', // 编辑
  Approve = 'approve', // 通过
  Reboot = 'reboot', // 重新提交
}

/**
 * @Description 审批详情特殊页面No
 */
export enum ApprovePageNo {
  KFGSTZ001 = 'KFGSTZ001', // 跨公司调整页面1
  KFGSTZ002 = 'KFGSTZ002', // 跨公司调整页面2
  KFGSTZ003 = 'KFGSTZ003', // 跨公司调整页面3
  GHZRR001 = 'GHZRR001', // 更换责任人
  EVALUATION001 = 'EVALUATION001', // 点位评估通过审批时需要上传附件
}

// 审批类型
export enum ApprovalType {
  ChancePoint = 1, // 机会点
  TaskChange = 2, // 拓店任务异动
  ShopEvaluation = 3, // 点位评估
  DesignAdvance = 4, // 提前设计
  ShopProtect = 5, // 门店保护
  Contract = 6, // 合同审批
  ShopStatusChange = 7, // 门店状态变更审批
  PlanSpot = 8, // 集客点
  DirectTask = 9, // 选址地图创建的拓店任务审批
  ModelCluster = 10, // 选址地图开店区域
  AreaProtection = 11, // 区域保护（防撞店）特殊申请
}

// 审批类型
export enum ApprovalTypeValue {
  /**
   * 机会点审批
   */
  ChancePointEvaluate = 1, // 机会点审批
  /**
   * 开发异动
   */
  SelectToEvaluation = 2, // 选址转测评
  EvaluationToSelect = 3, // 测评转选址
  TerminateTask = 4, // 终止任务
  TransferTask = 5, // 变更责任人
  ChangeOffice = 6, // 跨分公司调整
  Other = 7, // 其他
  /**
   * 店铺评估
   */
  ShopEvaluation = 8, // 店铺评估
  /**
   * 设计申请
   */
  DesignAdvance = 9, // 设计申请
  /*
   * 门店报告
   */
  ShopProtect = 10, // 门店保护
  /*
   * 合同审批
   */
  Contract = 11, // 合同审批
  StoreHouseDelivery = 12, // 门店交房
  StoreOpen = 13, // 盛大开业
  StoreClose = 14, // 闭店

  /**
   * 规划申请
   */
  PlanDelivery = 15, // 网规
  /**
   * 集客点
   */
  PlanSpot = 16, // 集客点
  /**
   *  添加网规申请
   */
  AddNetWork = 17, // 添加网规申请17
  /**
   * 选址地图发起拓店任务(直营)
   */
  DirectTask = 18,
  /**
   * 选址-集客点审批
   */
  SiteMapGatherClient = 19,
  /**
   * 区域保护（防撞店）特殊申请
   */
  AreaProtection = 20,
  /**
   * 选址地图发起拓店任务指派开发主管
   */
  TaskAssignLeader = 1101,
  /**
   * 选址地图开店区域
   */
  ModelClusterCreate = 1001,
  /**
   * 门店编辑审批
   */
  ShopEditApproval = 21,
  /**
   * 门店状态变更审批
   */
  ShopStatusChange = 22,
}

/** 区域保护（防撞店）特殊申请以审批类型与审批子类型共同唯一标识。 */
export const isAreaProtectionApproval = (type?: number, typeValue?: number) => {
  return type === ApprovalType.AreaProtection && typeValue === ApprovalTypeValue.AreaProtection;
};

/**
 * @Description 机会点详情模块定义
 */
export enum ChanceDetailModule {
  /** 核心信息 */
  Basic = 1,
  /** 雷达图 */
  Radar = 2,
  /** 收益预估 */
  Benifit = 3,
  // 动态表单详情
  /** 详情（含动态表单） */
  Detail = 4,
  /** 踩点组件 */
  Footprint = 5,
  /** 亚瑟士定制 */
  Asics = 6,
  /** 拓店任务信息 */
  Task = 7,
  /** 项目综述 */
  Overview = 8,
  /** 商圈信息 */
  BusinessAreaModule = 9,
  /** 出价管理 */
  BidManagement = 10,
  /** 客流计数（前端自定义，益禾堂租户且有关联踩点时展示） */
  RelationCheckPoints = 101,
  /** 踩点记录列表（前端自定义） */
  RelationSpotSurveys = 102,
}

export const RelationCheckPointsModule = {
  moduleType: ChanceDetailModule.RelationCheckPoints,
  moduleTypeName: '客流计数',
  isShow: true,
};

export const RelationSpotSurveysModule = {
  moduleType: ChanceDetailModule.RelationSpotSurveys,
  moduleTypeName: '踩点记录',
  isShow: true,
};

/**
 * @Description 机会点状态定义
 */
export enum ChanceStatus {
  Draft = 0, // 草稿
  WaitApprove = 100, // 代审批（待匹配）
  Approving = 200, // 审批中
  Pass = 300, // 通过
  Reject = 400, // 未通过
  WaitReport = 500, // 待提报
  Estimating = 600, // 评估中
  Estimated = 700, // 评估通过
  EstimateFail = 800, // 评估未通过
  Signing = 900, // 签约中
  Complete = 1000, // 已落位
  Close = 1100, // 已关闭
}

/** 机会点状态颜色值 */
export const ChancePointStatusColor = {
  [ChanceStatus.WaitApprove]: '#222222',
  [ChanceStatus.Approving]: '#FF861D',
  [ChanceStatus.Pass]: '#009963',
  [ChanceStatus.Reject]: '#F53F3F',
  [ChanceStatus.WaitReport]: '#222222',
  [ChanceStatus.Estimating]: '#FF861D',
  [ChanceStatus.Estimated]: '#009963',
  [ChanceStatus.EstimateFail]: '#F53F3F',
  [ChanceStatus.Signing]: '#FF861D',
  [ChanceStatus.Complete]: '#009963',
  [ChanceStatus.Close]: '#999999',
};

/** 机会点保护状态名称 */
export const ProtectString = {
  On: '保护中',
  Off: '未保护',
};

/** 机会点保护状态颜色值 */
export const ProtectStatusColor = {
  [ProtectString.On]: '#009963',
  [ProtectString.Off]: '#F23030',
};

// 门店状态
export enum StoreStatus {
  Signed = 100, // 已签约
  HouseDeliverApproving = 200, // 交房审批中
  HouseDelivered = 300, // 已交房
  OpenApproving = 400, // 开业审批中
  Opened = 500, // 开业中
  CLoseApproving = 600, // 闭店审批中,
  Closed = 700, // 已闭店
  Relocated = 800, // 已迁址
  Terminated = 900, // 已解约
}

// 门店-租金模式
export enum RentalModel {
  Fixed = 1, // 固定
  Reduce = 2, // 扣点
  High = 3, // 取高
  Other = 4, // 其他
}

/**
 * @Description 机会点详情权限（app、pc保持定义一致）
 */
export enum ChanceDetailPermission {
  ShareEdit = 'shareEdit', // 发给微信好友填写
  Edit = 'edit', // 编辑机会点
  SubmitApprove = 'submitApproval', // 提交审批
  Revoke = 'revokeApproval', // 撤销审批
  Protect = 'submitProtect', // 发起保护
  ContractApply = 'contractApply', // 合同签约
  Record = 'record', // 跟进记录
  ReportExport = 'reportExport', // 报告导出
  YmDecision = 'ymDecision', // 一鸣决策报告
  SaasDecision = 'saasDecision', // 商圈决策报告
  Recycle = 'recycle', // 废弃
}

/**
 * @Description 功能开关-机会点详情是否支持编辑机会点
 */
export const IS_DETAIL_EDIT_CHANCE = true;


// 拓店任务指派归属类型
export enum AssignType {
  Member = 1, // 直接指派成员
  Twice = 2, // 二次指派
  ThreeTimes = 3, // 三次指派
}

/*
  任务状态 status(1:进行中 2:已完成 3:已变更 4:已关闭)
  全局通用枚举，非必要不拷贝该枚举定义到个别页面处理
*/
export enum TaskStatus {
  /** 待指派 */
  WaitAssign = 10,
  /** 进行中 */
  Processing = 20,
  /** 已变更 */
  Changed = 30,
  /** 已完成 */
  Complete = 40,
  /** 已关闭 */
  Closed = 50,
}

/** 任务状态颜色值 */
export const TaskStatusColor = {
  [TaskStatus.WaitAssign]: '#92A5CA',
  [TaskStatus.Complete]: '#009963',
  [TaskStatus.Changed]: '#F53F3F',
  [TaskStatus.Closed]: '#999999',
  [TaskStatus.Processing]: '#FF8400',
};

/**
 * 任务状态标签颜色值
 *   使用场所：拓店任务详情抽屉（普通）、
 *          拓店任务详情抽屉（选址地图拓店任务）、
 * */
export const TaskStatusTagStyle = {
  [TaskStatus.WaitAssign]: {
    background: 'rgba(146,165,202,0.07)',
    color: '#222222',
  },
  [TaskStatus.Processing]: {
    background: 'rgba(255, 134, 29, 0.06)',
    color: '#FF861D'
  },
  [TaskStatus.Changed]: {
    background: 'rgba(245, 63, 63, 0.08)',
    color: '#F53F3F',
  },
  [TaskStatus.Complete]: {
    background: 'rgba(0, 153, 99, 0.06)',
    color: '#009963',
  },
  [TaskStatus.Closed]: {
    background: 'rgba(146, 165, 202, 0.07)',
    color: '#7886A1',
  },
};

// 任务异动状态  0：否  1：审核中  2：审核通过
export enum TaskChange {
  None = 0, // 否
  Approving = 1, // 审核中
  Passed = 2, // 审核通过
}

// 拓店任务tab key（与接口约定的拓店任务列表tab字段值）
export enum TaskTab {
  /** 指派我的 */
  AssignMe = '1',
  /** 我创建的 */
  Created = '2',
  /** 待指派 */
  WaitAssign ='3',
}

// 仅限作为【加盟+直营】拓店任务模板场景下，作为【业务模式】字段值使用
export enum BusinessMode {
  Franchisee = 1, // 加盟商
  Direct = 2, // 直营
  Joint = 3, // 联营模式
};

// 任务紧急度枚举
export enum EmergencyDegree {
  Very = 1, // 非常紧急
  Quite = 2, // 紧急
  Normal = 3, // 一般
  Not = 4, // 不紧急
};

// 卡旺卡租户专用-任务紧急度枚举
export enum KWKEmergencyDegree {
  Passenger = 100, // 踩点
  PassengerOneWeek = 101, // 踩点-1周内完成
  PassengerTwoWeek = 102, // 踩点-1周内完成
  Chance = 200, // 备选点
  ChanceTwoWeek = 201, // 备选点-2周内完成
  ChanceFourWeek = 202, // 备选点-4周内完成
};

/**
 * @description 是否对紧急度颜色高亮
 * @param degree 紧急度值
 * @return true 高亮
 */
export const isHighlightEmergencyDegree = (degree) => {
  return [EmergencyDegree.Very,
    EmergencyDegree.Quite,
    KWKEmergencyDegree.PassengerOneWeek,
    KWKEmergencyDegree.ChanceTwoWeek].includes(degree);
};
/**
 * @description 是否对紧急度颜色高亮(踩点紧急度\备选点上传紧急度)
 * @param degree 紧急度值
 * @return true 高亮
 */
export const isHighlightChancePointEmergencyDegree = (degree) => {
  return [EmergencyDegree.Very].includes(degree);
};

/**
 * @description 是否对紧急度颜色高亮
 * @param degree 紧急度值
 * @return true 高亮
 */
export const isShowEmergencyIcon = (degree) => {
  return [EmergencyDegree.Very,
    KWKEmergencyDegree.PassengerOneWeek,
    KWKEmergencyDegree.ChanceTwoWeek].includes(degree);
};

/**
 * @description 获取卡旺卡任务紧急度值的完整值
 * @param degree 紧急度最后一级值
 * @return 返回包含父节点的完整值，比如输入 101（踩点-1周内完成），返回一级和二级[100, 101]
 */
export const getKWKEmergencyFullDegree = (degree) => {
  return [KWKEmergencyDegree.PassengerOneWeek, KWKEmergencyDegree.PassengerTwoWeek].includes(degree) ? [KWKEmergencyDegree.Passenger, degree] : [KWKEmergencyDegree.ChanceTwoWeek, KWKEmergencyDegree.ChanceFourWeek].includes(degree) ? [KWKEmergencyDegree.Chance, degree] : undefined;
};

export const FranchiseeTypeNameJoint = '联营商';

/**
 * @description 加盟商字段标题
 * @param businessMode 【加盟+直营】拓店任务模板场景下【业务模式】字段值
 * @return 判断是否联营模式，需要特殊显示
 */
export const franchiseeTitleForMode = (businessMode) => {
  const isJoint = businessMode === BusinessMode.Joint;
  return isJoint ? '联营商姓名' : '加盟商姓名';
};

/**
 * @description 加盟商字段简略标题
 * @param businessMode 【加盟+直营】拓店任务模板场景下【业务模式】字段值
 * @return 判断是否联营模式，需要特殊显示
 */
export const franchiseeShortTitleForMode = (businessMode) => {
  const isJoint = businessMode === BusinessMode.Joint;
  return isJoint ? '联营商' : '加盟商';
};

/**
 * @description 加盟商唯一识别符字段的默认标题
 * @param businessMode 【加盟+直营】拓店任务模板场景下【业务模式】字段值
 * @return 判断是否联营模式，需要特殊显示
 */
export const uniqueDefaultNameForMode = (businessMode) => {
  const isJoint = businessMode === BusinessMode.Joint;
  return isJoint ? '联营商唯一标识' : '加盟商唯一标识';
};
/**
 * 卡旺卡定制逻辑：动态表单计算预估销售额。完整计算公式 预估销售额 = 开店区域理论月度销售额*（1+评分影响值）。
 * 以下字段是参与计算的单选框/下拉框选中值对应的 评分影响值
 */
export const customEstimateSalesKWK = {
  microscopicposition: [ // 微观位置
    { name: '千分点', value: 0.1 },
    { name: 'A+点', value: 0.05 },
    { name: 'A点', value: 0 },
    { name: 'A-点', value: -0.05 },
    { name: 'B点', value: -0.1 },
  ],
  targetimage: [
    { name: '单展面', value: 0.1 },
    { name: '两个或两个以上', value: 0.05 },
  ],
  logoOuntput: [
    { name: 'A+', value: 0.1 },
    { name: 'A', value: 0.05 },
    { name: 'B', value: 0 },
    { name: 'B-', value: -0.05 },
  ],
  isItObstructed: [
    { name: '无', value: 0 },
    { name: '有一定阻挡', value: -0.05 },
    { name: '有比较大的遮挡', value: -0.1 },
  ],
  step1kwk: [
    { name: '0', value: 0 },
    { name: '1-3', value: -0.05 },
    { name: '4-5', value: -0.1 },
    { name: '>5', value: -0.2 },
  ],
  parkingCondition1kwk: [
    { name: '可停车', value: 0.05 },
    { name: '不可停车', value: -0.05 },
  ],
  oppositeSideConvenience1kwk: [
    { name: '步行1分钟内', value: 0.1 },
    { name: '步行1-3分钟内', value: 0 },
    { name: '步行3-5分钟内', value: -0.1 },
  ],
  sideConvenience1kwk: [
    { name: '无阻隔直接进店', value: 0.05 },
    { name: '有阻隔无法直接进店', value: -0.05 },
  ],
};

export const customEstimateSalesKWKOfNumberFields = [
  'basicUsableArea',
  'specWideLocation',
];
// 卡旺卡实用面积输入返回分影响值
export const customEstimateSalesKWKOfBasicUsableArea = (value: string | number) => {
  const num = +value;
  if (num > 77) return 0.05;
  if (num > 63 && num <= 77) return 0;
  if (num > 56 && num <= 63) return -0.05;
  if (num <= 56) return -0.1;
  return 0;
};

// 卡旺卡面宽内径输入值返回分影响值
export const customEstimateSalesKWKOfSpecWideLocation = (value: string | number) => {
  const num = +value;
  if (num > 10) return 0.1;
  if (num > 8 && num <= 10) return 0;
  if (num > 5 && num <= 8) return -0.05;
  if (num <= 5) return -0.1;
  return 0;
};

// 动态表单组件中校验上传组件中的上传状态
export const checkDynamicFormUploadStatus = (allComps: any[]) => {
  // 上传类型的组件也要校验是否上传完毕，如果还在上传中也要校验
  const uploadComs = allComps?.filter((itm: any) => itm.controlType === ControlType.UPLOAD.value);
  if (isArray(uploadComs) && uploadComs.length) {
    let uploadIsComplete = true;
    uploadComs.forEach((uploadComItem: any) => {
      const { textValue } = uploadComItem;
      if (textValue && typeof textValue === 'string') {
        const textValueObj = parseValueCatch(uploadComItem);
        if (!(isArray(textValueObj) && textValueObj.length)) return;
        const uncompleted = textValueObj.filter((targetItem: any) => !(targetItem.name && targetItem.url));
        if (uncompleted?.length > 0) uploadIsComplete = false;
      }
    });
    if (!uploadIsComplete) {
      V2Message.warning('文件上传中...');
      return false;
    };
  }
  return true;
};
